import { useHover } from "react-aria";

import { useOverlay } from "./useOverlay.ts";

interface HoverInteractiveOptions {
  isOpen: boolean;
}

export const useHoverInteractive = (options: HoverInteractiveOptions = { isOpen: false }) => {
  const { hoverProps, isHovered } = useHover({});
  const { overlayProps, state, triggerProps } = useOverlay({ isOpen: isHovered || options.isOpen });

  return {
    triggerProps,
    overlayProps,
    hoverProps,
    state,
  };
};
